import { render, staticRenderFns } from "./InvestmentHistoryItem.vue?vue&type=template&id=6dce0610&scoped=true"
import script from "./InvestmentHistoryItem.vue?vue&type=script&lang=ts"
export * from "./InvestmentHistoryItem.vue?vue&type=script&lang=ts"
import style0 from "./InvestmentHistoryItem.vue?vue&type=style&index=0&id=6dce0610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dce0610",
  null
  
)

export default component.exports